<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="phoneNumberAudits && phoneNumberAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="phoneNumberAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Phone Number audits </ng-template>
</ng-template>
